(function () {
    'ngInject';

    angular.module('app.shared.services').factory('ProductAPIService', productAPIService);

    function productAPIService(HttpService) {
        function renameProduct(productId, newName) {
            var data = {
                productId: productId,
                name: newName
            };
            var url = '/Product/Rename?' + $.param(data);
            return HttpService.post(url);
        }

        function generateProductGUID() {
            return HttpService.get('/Product/ProductGUID');
        }

        function getProduct(id) {
            const data = {
                productId: id,
                useListEPS: true
            };
            return HttpService.get('/Product?' + $.param(data));
        }

        function saveProduct(product) {
            var url = '/Product/SaveProduct';
            var data = {
                // New payload shape (avoids jsonString escaping):
                // { product: { ... } }
                product: product
            };
            return HttpService.post(url, data);
        }

        function getProducts(
            searchString,
            sortBy,
            sortMode,
            from,
            pageSize,
            linked = undefined,
            deleted = undefined,
            fullAccessOnly = undefined,
            tagIds = undefined
        ) {
            var data = {
                searchString: searchString,
                sortBy: sortBy,
                sortMode: sortMode,
                from: from,
                pageSize: pageSize,
                linked,
                deleted,
                fullAccessOnly
            };
            if (tagIds && tagIds.length) {
                data.tagIds = tagIds;
            }
            // Web API's [FromUri] List<int> binder expects a repeated query key (?tagIds=1&tagIds=2);
            // jQuery's "traditional" param mode ($.param(data, true)) serializes array values that way.
            return HttpService.get('/Product/GetProducts?' + $.param(data, true));
        }

        function getProductsCount(
            searchString,
            linked = undefined,
            deleted = undefined,
            fullAccessOnly = undefined,
            tagIds = undefined
        ) {
            var data = {
                searchString: searchString,
                linked,
                deleted,
                fullAccessOnly
            };
            if (tagIds && tagIds.length) {
                data.tagIds = tagIds;
            }
            return HttpService.get('/Product/GetProductsCount?' + $.param(data, true));
        }

        function assignTags(productId, tagIds, newTagNames) {
            var data = {
                productId: productId,
                tagIds: tagIds,
                newTagNames: newTagNames
            };
            return HttpService.post('/Product/AssignTags', data);
        }

        function deleteProduct(productId) {
            var data = {
                productId: productId
            };
            return HttpService.get('/Product/DeleteProduct?' + $.param(data));
        }

        function deleteProductRange(productIds) {
            return HttpService.post('/Product/DeleteProductRange', JSON.stringify({ productIds }));
        }

        function restoreProduct(id) {
            var data = {
                id: id
            };
            return HttpService.post('/Product/RestoreProduct?' + $.param(data));
        }

        function cloneProduct(id) {
            var data = {
                productId: id
            };
            return HttpService.get('/Product/CloneProduct?' + $.param(data));
        }

        function getProductsWithFont(fontName) {
            var data = {
                fontName: fontName
            };
            return HttpService.get('/Product/GetProductsWithFont?' + $.param(data));
        }

        function getExportUrl(productId) {
            return HttpService.get(`/Product/${encodeURIComponent(productId)}/ExportUrl`);
        }

        function getProductImportSignedUrl() {
            return HttpService.get(`/Product/ImportSignedUrl`);
        }

        function importProductZip(filename) {
            return HttpService.get(`/Product/Import/${encodeURIComponent(filename)}`);
        }

        function getProductTemplateRelations(productId) {
            var data = {
                productId: productId
            };
            return HttpService.get('/Product/ProductTemplateRelations?' + $.param(data));
        }

        return {
            getProduct: getProduct,
            generateProductGUID: generateProductGUID,
            saveProduct: saveProduct,
            getProducts: getProducts,
            getProductsCount: getProductsCount,
            deleteProduct: deleteProduct,
            cloneProduct: cloneProduct,
            getProductsWithFont: getProductsWithFont,
            renameProduct: renameProduct,
            getExportUrl: getExportUrl,
            getProductImportSignedUrl: getProductImportSignedUrl,
            importProductZip: importProductZip,
            restoreProduct,
            getProductTemplateRelations: getProductTemplateRelations,
            deleteProductRange,
            assignTags: assignTags
        };
    }
})();
